import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() title: string = '';
  @Input() searchType: boolean = false;
  @Input() gross: boolean = false;
  @Input() medium: boolean = false;
  @Input() small: boolean = false;
  @Input() disabled: boolean = false;
  @Input() redAlert: boolean = false;
}
